import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { signupFuncionario } from 'services/usuarios';
import validarCPF from 'validar-cpf';

export default function ModalPrimeiroAcesso({ show, onHide, onSuccess }) {
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const cpf = form.formCPF.value;
    const senha = form.formSenhaNova.value;
    const confirmPassword = form.formConfirmSenha.value;

    if (!validarCPF(cpf)) {
      toast.error('CPF inválido');
      return;
    }

    if (senha !== confirmPassword) {
      toast.warning('As senhas não correspondem.');
      return;
    }

    if (senha.length < 4) {
      toast.warning('A senha deve ter no mínimo 4 caracteres.');
      return;
    }

    try {
      setLoading(true);
      await signupFuncionario(cpf, senha);
      toast.success('Senha criada com sucesso! Faça login agora.');
      setValidated(false);
      onSuccess();
      onHide();
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Erro ao criar senha. Verifique seu CPF.';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Primeiro acesso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group controlId="formCPF" className="mb-3">
            <Form.Label>CPF</Form.Label>
            <Form.Control required type="text" placeholder="Digite seu CPF" />
            <Form.Control.Feedback type="invalid">
              Por favor, informe um CPF válido.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formSenhaNova" className="mb-3">
            <Form.Label>Nova Senha</Form.Label>
            <Form.Control
              required
              type="password"
              placeholder="Digite sua nova senha (mínimo 4 caracteres)"
              minLength="4"
            />
            <Form.Control.Feedback type="invalid">
              Por favor, informe uma nova senha (mínimo 4 caracteres).
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formConfirmSenha" className="mb-3">
            <Form.Label>Confirmar Senha</Form.Label>
            <Form.Control
              required
              type="password"
              placeholder="Confirme sua nova senha"
              minLength="4"
            />
            <Form.Control.Feedback type="invalid">
              Por favor, confirme sua senha.
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end mb-2">
            <Button type="submit" variant="primary" className="flex-grow-1" disabled={loading}>
              {loading ? 'Criando...' : 'Criar senha'}
            </Button>
          </div>
          <div className="d-flex">
            <Button
              type="button"
              variant="danger"
              className="flex-grow-1"
              onClick={onHide}
              disabled={loading}
            >
              Cancelar
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
